






























import { Component, Vue, Watch } from "vue-property-decorator";
import Api from "@/api";
import { IPartner } from "@/interface";
import { AxiosResponse } from "axios";

@Component
export default class Partners extends Vue {
  private selectedPartner: number | null = null;
  private partners: Array<IPartner> = [];
  private partnerId: number = parseInt(localStorage.partnerId, 10);

  private mounted(): void {
    this.getPartners();
  }

  private onChangePartner(partner: number): void {
    this.selectedPartner = partner;
  }

  private getPartners(): void {
    Api()
      .get("api/internal/v1/users/current/partners")
      .then((response: AxiosResponse) => {
        this.partners = response.data.data;
      })
      .catch((e: any) => {
        console.log(e);
      });
  }

  @Watch("selectedPartner")
  selectedPartnerChanged(newState: IPartner): void {
    localStorage.setItem("partnerId", `${newState.id}`);
    localStorage.setItem("partnerCode", `${newState.code}`);
    if (newState.id) {
      this.partnerId = newState.id;
    }
    window.location.reload();
  }
}
